module.exports = __webpack_public_path__ + "img/5@s.fcbb272e.jpg";